import { createSelector } from 'reselect'

const getLanguageMessages = (state) => state.LanguageSwitcher.get('languageMessages');

const getLanguageMessage = (state, key = null) => createSelector(
  [ getLanguageMessages ],
  (languageMessages) => {    
    return (languageMessages && languageMessages[key])? languageMessages[key] : '';
  }
)(state)

export { 
  getLanguageMessage
}